<template>
  <div class="nft-transaction-explorer mt-6 md:mt-14" v-if="nftData && Object.keys(nftData).length">
    <Paragraph class="text-blue-dark font-jost-regular text-[25px]" text="Digital Asset ID" />
    <div class="flex items-center max-w-max relative w-auto mb-4 md:mb-[95px]">
      <p class="text-blue-light break-all font-jost-regular w-full text-blue-light text-left" style="font-size: 25px">
        {{ nftDetails.accountNumApp }}
      </p>
      <CopyIcon :isActive="checkIfIsEqual(nftDetails.accountNumApp, 'from')" @click="copy(nftDetails.accountNumApp, 'from')" title="Copy hash"
        class="min-w-[20px] h-[22px] inline-block cursor-pointer align-text-top ml-[10px]" />
    </div>
    <section class="section-nft flex gap-[50px] items-start">
      <div class="max-w-[90%] md:max-w-[100%]">
        <!-- <Paragraph class="text-blue-dark font-jost-regular text-[25px] mb-[10px]" :text="nftTitle" /> -->
        <div class="p-[30px] rounded-[6px] bg-white h-auto mt-[40px]">
          <img class="object-contain w-full h-full max-w-[400px]" :src="`${getNftImageUrl(nftDetails.metaData) || placeholderImg}`" />
        </div>
      </div>
      <div class="h-auto max-w-[90%] md:max-w-[100%]">
        <Paragraph class="text-blue-dark font-jost-regular text-[24px] leading-[30px] mb-[10px]" text="Verification" />
        <section class="t-results text-lg bg-white rounded-[6px] py-[38px] px-[20px]">
          <div
            class="row text-left justify-start text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-start flex-wrap md:flex-nowrap gap-2 md:gap-[50px]">
            <div class="col text-blue-dark font-jost-regular block flex relative min-w-[140px] text-base">
              Owner
            </div>
            <router-link v-if="nftDetails.owner" :to="{path: getLinkToAccount(nftDetails.owner)}"
              class="col block px-2.5 flex relative text-blue-light cursor-pointer break-all gap-[17px] items-baseline text-base">
                {{ nftDetails.owner }}
            </router-link>
            <CopyIcon :isActive="checkIfIsEqual(nftDetails.owner, 'owner')" @click="copy(nftDetails.owner, 'owner')"
                title="Copy issuer address" class="min-w-[19px] cursor-pointer" />
          </div>
          <div
            class="row text-left justify-start text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-start flex-wrap md:flex-nowrap gap-2 md:gap-[50px]">
            <div class="col text-blue-dark font-jost-regular block flex relative min-w-[140px] text-base">
              Issuer
            </div>
            <router-link v-if="nftDetails.issuer" :to="{path: getLinkToAccount(nftDetails.issuer)}"
              class="col block px-2.5 flex relative text-blue-light cursor-pointer break-all gap-[17px] items-baseline text-base">
                {{ nftDetails.issuer }}
            </router-link>
            <CopyIcon :isActive="checkIfIsEqual(nftDetails.issuer, 'from')" @click="copy(nftDetails.issuer, 'from')"
                title="Copy issuer address" class="min-w-[19px] cursor-pointer" />
          </div>
          <div
            class="row text-left justify-start text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-start flex-wrap md:flex-nowrap gap-2 md:gap-[50px]">
            <div class="col text-blue-dark font-jost-regular block flex relative min-w-[140px] text-base">
              Chain
            </div>
            <router-link :to="{ name: 'chain', params: { chainNumber: nftDetails.chainNumber } }"
             class="col block px-2.5 flex relative text-blue-light break-all text-base">
              #{{ nftDetails.chainNumber }}
            </router-link>
          </div>

          <div
            class="row text-left justify-start text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-start flex-wrap md:flex-nowrap gap-2 md:gap-[50px]">
            <div class="col text-blue-dark font-jost-regular block flex relative min-w-[140px] text-base">
              Created At
            </div>
            <div class="col px-2.5 flex relative text-blue-dark cursor-pointer flex justify-between text-ellipsis">
              <div>
                <span class="block font-jost-regular text-ellipsis text-base">
                  Block
                  <router-link v-if="nftData && nftDetails.blockNumber" class="text-blue-light cursor-pointer text-base"
                    :to="{ name: 'block', params: { chainNumber: nftDetails.chainNumber || $route.params.chainNumber || $route.params.chain, blockNumber: nftDetails.blockNumber } }">
                    #{{ nftDetails.blockNumber }}
                  </router-link>
                </span>
                <span class="block font-jost-regular text-ellipsis text-base cursor-default">
                  {{ formatDate(nftDetails.createdAt) }}
                </span>
              </div>
              <router-link v-if="nftData && nftDetails.txRefHash"
                :to="{ name: 'transaction', params: { chainNumber: nftDetails.chainNumber || $route.params.chainNumber || $route.params.chain, txRefhash: nftDetails.txRefHash } }"
                class="text-blue-light !text-inter-medium">
                <img class="cursor-pointer" src="/images/icons/icon-ionic-md-open.svg" />
              </router-link>
            </div>
          </div>
          <div
            class="row text-left justify-start text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-start flex-wrap md:flex-nowrap gap-2 md:gap-[50px]">
            <div class="col text-blue-dark font-jost-regular block flex relative min-w-[140px] text-base">
              Attestation Hash
            </div>
            <p class="col block px-2.5 flex relative text-blue-dark break-all gap-[17px] items-center text-base">
              {{ nftDetails.attestationHash }}
              <CopyIcon :isActive="checkIfIsEqual(nftDetails.attestationHash, 'from')" @click="copy(nftDetails.attestationHash, 'from')" title="Copy hash"
                class="min-w-[19px] inline-block cursor-pointer align-text-top ml-[10px]" />
            </p>
          </div>

          <div class="row text-left justify-start text-blue-dark px-2.5 py-3.5 result-row flex items-start flex-wrap gap-2 md:gap-[50px]">
            <div class="col text-blue-dark font-jost-regular block flex relative min-w-[140px] text-base">
              Digital Asset Metadata
            </div>
            <div class="col block text-ellipsis text-blue-dark">
              <p class="block font-jost-regular text-ellipsis break-all text-base" v-for="(i, ind) in nftDetails.metadata"
                :key="ind">
                {{ i }}{{ ind !== nftDetails.metadata.length - 1 ? ',' : '' }}
              </p>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
  <Paragraph text="We couldn't find any results.." class="text-lg mt-5 !text-left" v-else />
    <div class="h-auto m-auto max-w-[90%] md:max-w-[100%]">
      <Paragraph class="text-blue-dark font-jost-regular text-[24px] leading-[30px] mb-[10px] mt-[30px]" text="Transactions" />
      <div v-if="isTransactionsLoading" class="flex items-center justify-center py-6">
        <Paragraph class="sr-only" text="Loading transactions" />
        <div class="animate-pulse text-blue-dark">Loading...</div>
      </div>
      <SearchableTable 
        :transactions="nftTransactions || []" 
        :copied="copied"
        :initialFilters="{ type: 'nftMint' }"
        @copied="handleCopied"
        @filtersChanged="handleFiltersChanged"
      />
      <div class="flex justify-end px-[25px]">
        <pagination-component :items="nftTransactions.totalCount" :initialPage="getInitialPage()"
          @changePage="setFoundResult" class="float-left" />
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { maxTableRows } from '@/utils/pagination';

import api from '@/helpers/api';
import string from '@/helpers/string';
import { formatDate } from '@/helpers/date';

import SearchableTable from '@/components/common/SearchableTable.vue';
import PaginationComponent from '@/components/common/PaginationComponent.vue';

import Paragraph from '@/components/web/ParagraphComponent';
import CopyIcon from '@/components/svg/CopyIcon';
import { getLinkToAccount } from '@/helpers/common';

import {
  AccountType,
  getAccountTypeFromBase58String } from '@/utils/accountType';

const TRANSACTION_TYPE_VALUES = ['attestCommit', 'coin', 'proxyCreate', 'nftMint'];

export default {
  name: "NftComponent",
  components: {
    SearchableTable,
    PaginationComponent,
    Paragraph,
    CopyIcon,
  },
  data: () => {
    return {
      pageSize: maxTableRows,
      initialPage: 1,
      isNftLoading: false,
      isTransactionsLoading: false,
      nftData: {},
      placeholderImg: "/images/placeholder.jpg",
      copied: '',
      transactionFilters: {
        type: ['nftMint', 'coin'],
        minBlock: undefined,
        maxBlock: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        from: undefined,
        to: undefined,
        status: ['valid', 'invalid'],
      },
      nftTransactions: {
        meta: {},
        result: []
      }
      ,
    }
  },
  computed: {
    chainNumber() {
      return this.$route.params.chainNumber ? parseInt(this.$route.params.chainNumber, 10) : undefined;
    },
    nftDetails() {
      return this.nftData.result;
    },
    nftMetaDetails() {
      return this.nftData.meta || {};
    },
    nftId() {
      return this.$route.params.nftId || '';
    },
    routeName() {
      return this.$route.name
    },
    nftTitle() {
      return this.nftData.metaData ? this.nftData.metaData[0] : '';
    }
  },
  created() {
    this.initializeTransactionFilters();
    this.getByNftId(this.nftId);
    this.fetchTransactions(0);
  },
  methods: {
    initializeTransactionFilters() {
      this.transactionFilters = {
        type: ['nftMint', 'coin'],
        minBlock: undefined,
        maxBlock: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        from: undefined,
        to: undefined,
        status: ['valid', 'invalid'],
      };
    },
    fetchTransactions(skip = 0) {
      this.isTransactionsLoading = true;

      const params = {
        accountNumApp: this.nftId,
        chainNumber: this.chainNumber,
        type: this.transactionFilters.type,
        minBlock: this.transactionFilters.minBlock,
        maxBlock: this.transactionFilters.maxBlock,
        dateFrom: this.transactionFilters.dateFrom,
        dateTo: this.transactionFilters.dateTo,
        from: this.transactionFilters.from,
        to: this.transactionFilters.to,
        status: this.transactionFilters.status,
        limit: maxTableRows,
        skip,
      };

      api.getTransactionsByType(params)
        .then((res) => {
          this.nftTransactions = {
            ...res.data,
            skip,
          };
          this.isTransactionsLoading = false;
        })
        .catch(() => {
          this.isTransactionsLoading = false;
        });
    },
    getLinkToAccount(walletAddress) {
      return getLinkToAccount(walletAddress, this.nftDetails.chainNumber);
    },
    getNftImageUrl(metas) {
      const fileUrl = this.nftMetaDetails && this.nftMetaDetails.images
        ? this.nftMetaDetails.images[0].url
        : null;
      return fileUrl ? fileUrl : '';
    },
    findItemStartingWith(arr, keyName) {
      if (!arr || !arr.length) return null;

      for (const item of arr) {
        if (item.startsWith(keyName)) {
          return item.substring(2);
        }
      }
      return null;
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    formatDate(d) {
      return formatDate(d);
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    setCopied(hash) {
      this.copied = hash;
    },
    getItem(page) {
      const normalizedPage = Number(page) > 0 ? Number(page) : 1;
      const skip = (normalizedPage - 1) * maxTableRows;
      this.fetchTransactions(skip);
    },
    getInitialPage() {
      const skip = Number(this.nftTransactions?.meta?.skip);
      if (Number.isFinite(skip) && skip >= 0) {
        return Math.floor(skip / this.pageSize) + 1;
      }
      return this.initialPage;
    },
    setFoundResult(data) {
      const page = Number(data?.page) > 0 ? Number(data.page) : 1;
      this.getItem(page);
    },
    getByNftId(nftId) {
      this.isNftLoading = true;
    
      api.getNftById(nftId, this.chainNumber)
        .then((res) => {
          this.nftData = res.data;
          this.isNftLoading = false;
        })
        .catch((err) => {
          this.isNftLoading = false;
        })
    },
    handleCopied(copiedText) {
      // Handle copied event from SearchableTable
      this.copied = copiedText;
      console.log('Copied:', copiedText);
    },
    handleFiltersChanged(filterData) {
      const types = Array.isArray(filterData.type)
        ? filterData.type
        : (filterData.type ? [filterData.type] : [...TRANSACTION_TYPE_VALUES]);

      const statuses = Array.isArray(filterData.status)
        ? filterData.status
        : (filterData.status ? [filterData.status] : []);
      const fromAddress = typeof filterData.from === 'string' && filterData.from.trim()
        ? filterData.from.trim()
        : undefined;
      const toAddress = typeof filterData.to === 'string' && filterData.to.trim()
        ? filterData.to.trim()
        : undefined;

      this.transactionFilters = {
        type: types,
        minBlock: filterData.blockMin ?? undefined,
        maxBlock: filterData.blockMax ?? undefined,
        dateFrom: filterData.dateFrom ?? undefined,
        dateTo: filterData.dateTo ?? undefined,
        from: fromAddress,
        to: toAddress,
        status: statuses.length ? statuses : ['valid', 'invalid'],
      };

      this.fetchTransactions(0);
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 1500px) {
  .section-nft {
    gap: 50px;
  }
}
@media only screen and (max-width: 1200px) {
  .section-nft {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 50px;
  }
}
@media only screen and (max-width: 767px) {
  .section-nft {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .t-results {
    padding: 16px 10px;
  }

  .result-row {
    flex-wrap: wrap;
  }
}
</style>
